import React, {useState, useRef} from 'react'
import {useStateContext} from '../context/StateContext';
import { matchNonConformities } from '../lib/tagLogic';
import {NonConformityPin, SaveButton, VisDiv, BackButton} from '../components';
import { v4 as uuidv4 } from 'uuid';
import { keyId, objectIsObject } from '../lib/utils';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { isGodMode } from '../lib/userPermissions';
import { addLogToDoc } from '../lib/utils';
import { referenceDoc } from '../components/gestioneDatabase/Docs';
import NoAccessMessage from '../components/NoAccessMessage';

const AddNonConformity = ({device, saveFn, data={}}) => {

    const [deviceNonConformitiesList, setDeviceNonConformitiesList] = useState([])
    const {
        setCurrentNonConformity,
        //currentTemplate,
        sUser,
        //nonConformities,
        setDeviceIndexPage,
       // deviceNonConformities,
        LDB

    } = useStateContext();

    const nonConformities = data?.nonConformities ? data?.nonConformities: useStateContext()?.nonConformities
    const currentTemplate = data?.currentTemplate ? data?.currentTemplate: useStateContext()?.currentTemplate

    const deviceNonConformitiesExpanded = !Array.isArray(device?.nonConformities) ? [] : device?.nonConformities?.map?.((item)=>{
        return({
            ...objectIsObject(item),
            device: referenceDoc(device?._id, device?._key)
        })
    })
    const deviceNonConformities = data?.currentTemplate ? deviceNonConformitiesExpanded: useStateContext()?.deviceNonConformities
    
    //console.log("wewecwece",deviceNonConformities, deviceNonConformitiesExpanded)

     // search-box
    const [searchValue, setSearchValue] = useState("");
    const searchRef = useRef();

    const nonConformititesFilter = (x) =>{
        // search-box
       const search =  x?.label?.toLowerCase()?.indexOf(searchValue.toLowerCase()) >= 0
       return search 
   }
       //search-box
       const onSearchClick = (e) => {
        e.stopPropagation()
      };
      const onSearch = (e) => {
        setSearchValue(e.target.value);
      };
      

    //==========

    const P = "nonConformity"
    const networkStatus = useNetworkStatus()
    const testing = false
    const now = Date.now()
    const docs = !Array.isArray(deviceNonConformitiesList) ? [] : deviceNonConformitiesList.map?.((item)=>{
        const doc = {
            _id: uuidv4(),
            postedBy: [{ _type: 'postedBy', _ref: sUser._id,  _key: keyId(), }], 
            createdOn: now,
            status:"DA FARE",
            comments:[],
            nNonConformities:"1",
            _key: keyId(),
            _type: "deviceNonConformity",
            image:[],
            nonConformity:{
                _ref: item._id,
                _type: "reference",
                _key: keyId(),
            }
        }
        const docWithLog = addLogToDoc(sUser,doc,"Creato Non Conformità")

        return docWithLog

    }
) 

    const templateNonConformities = matchNonConformities(device, nonConformities, currentTemplate)
    const filteredNonConfDevice = !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.(x=> x?.device?._ref ==  device?._id)
    const existingNonConformityIds = !Array.isArray(filteredNonConfDevice) ? [] : filteredNonConfDevice?.filter?.((x)=>x.status!=="COMPLETATO" && x.status!=="ARCHIVIATO").map?.((item)=> item.nonConformity?._ref)
    
    const nonConformitiesFiltered = !Array.isArray(templateNonConformities) ? [] :
    templateNonConformities
    ?.filter?.((x)=> !existingNonConformityIds?.includes(x._id) && !x?.deadline && !x?.fieldGenerated )
    ?.filter?.(nonConformititesFilter)
    ?.map?.(item =>item)

    const existingNonConformity = !Array.isArray(templateNonConformities) ? [] :
    templateNonConformities
    ?.filter?.((x)=> existingNonConformityIds?.includes(x._id))
    ?.map?.((item, index)=>{
        const currentNC = !Array.isArray(nonConformitiesFiltered) ? undefined : nonConformitiesFiltered?.find?.((x)=> x.nonConformity?._ref == item?._id)
        return(
        <div key={index} onClick={()=>setCurrentNonConformity(currentNC)} className='nonConformity-pin-container' style={{marginTop:"12px", padding:"5px"}}>
            <VisDiv rules={[testing]}>
                <button onClick={()=>{
                    //console.log(currentNC)
                }}>test</button>
            </VisDiv>
             <p>{item.label}</p>
        </div>
    )})

    const testFunction = () => {
        //console.log("currentTemplate", currentTemplate )

    }

    const existingNonConformities = device?.nonConformities ? device?.nonConformities : []

    const save = () => {
      
       const allNonConformities =  [
        ...!Array.isArray(existingNonConformities) ? [] : existingNonConformities, 
        ...!Array.isArray(docs) ? [] : docs
    ]    
        saveFn(allNonConformities)
    }

    function compare( a, b ) {
        if ( a?.label < b?.label ){
          return -1;
        }
        if ( a?.label > b?.label ){
          return 1;
        }
        return 0;
      }

    if(sUser?.userType == "Cliente"){
        return <NoAccessMessage/>  
    }

  return (
      <div className={networkStatus ? "new-device-container" : "new-device-container stop-scroll-refresh" }>
        <VisDiv rules={[isGodMode]}>
            <button onClick={testFunction}>test</button>
        </VisDiv>
        <BackButton onClick={()=>setDeviceIndexPage("DEVICE")}/>
        <div style={{padding:"8px"}}>
        <h4>{LDB("misc", "search")}</h4>
        </div>

        <div className="search-box" style={{backgroundColor:"white", fontSize:"12px"}}>
            <input onClick={(e)=>onSearchClick(e)} style={{fontSize:"18px"}} onChange={onSearch} value={searchValue} ref={searchRef} />
        </div>
        <div className="nonConformity-container" >        
            <h3>{LDB(P, "availableNonConformities")}</h3>
        </div>
        <VisDiv rules={[nonConformitiesFiltered.length<1]} style={{padding:"10px", color:"red", display:'flex', justifyContent:'center'}}>
          {LDB(P, "noAvailableNonConformities")}
        </VisDiv>       
        {!Array.isArray(nonConformitiesFiltered) ? [] : nonConformitiesFiltered?.sort(compare).map?.((item, index)=>{
            const isItemInArray = deviceNonConformitiesList?.some?.((x=>x?._id == item?._id))
            return(
                <div key={item?._id} className="nonConformity-container">

                        <NonConformityPin
                            label={item?.label}
                            initialValue = {isItemInArray}
                            item={item}
                            array={deviceNonConformitiesList}
                            setArray={setDeviceNonConformitiesList}
                        />
                </div>

            )
          })}
          <div style={{display:'flex', justifyContent:'center'}}>
            <h3>{LDB(P, "assignedNonConformities")}</h3>           
          </div>
          <div style={{display:'flex', justifyContent:'center', textAlign:'center', marginTop:"10px", flexDirection:"column"}}>
            {existingNonConformity.length>0 ? existingNonConformity : LDB(P, "noAssignedNonConformities")}
          </div>       
          <SaveButton
          cancelFunction={()=>setDeviceIndexPage("DEVICE")}
          saveFunction={save}
          />
      </div>
  )
}

export default AddNonConformity
